import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { Subject, take, takeUntil } from 'rxjs';
import { LayoutResultadoService } from '../layout-resultado/layout-resultado.service';
import { LayoutEdicaoService } from './layout-edicao.service';
import {
  EtapasDeEdicaoService,
  Opcoes,
} from '../../services/etapas-de-edicao/etapas-de-edicao.service';
import { StepperNavigationComponent } from '../../shared/stepper-navigation/stepper-navigation.component';
import { PopupValidacaoComponent } from '../../shared/stepper-navigation/components/popup-validacao/popup-validacao.component';
import { StepperEstadoService } from '../../services/stepper-estado.service';
import { LocalizacaoService } from '../../services/localizacao/localizacao.service';
import { EventoNavegacaoStepper } from '../../shared/stepper-navigation/interfaces/stepper.interface';
import {
  AcessoOfertaEducacionalStateService,
  CondicaoQualidadeStateService,
  MatriculasPorEscolaService,
  PQRAdicionaisService,
  PQRAlimentacaoEscolarService,
  PQRCargaHorarioEnsinoService,
  PQREncargosSociaisService,
  PQRFatorPonderacaoService,
  PQRFormacaoJornadaRemuneracaoProfessoresService,
  PQRManutencaoFormacaoMaterialService,
  PQRMultiplicadorAnualService,
  PQRNovasSalasPrediosService,
  PQRNumeroDiasLetivosService,
  PQRQuadroFuncionariosRemuneracaoService,
  PQRTamanhoMinimoTurmaService,
  PQRTamanhoTurmaService,
  PrecoEncargosAdicionaisStateService,
} from '../../services';
import { ValidacaoEtapaService } from '../../services/validacao-etapa/validacao-etapa.service';
import {
  ValidacaoResult,
  ValidadorTela,
} from '../../interfaces/validacao.interface';
import { TipoSimulacao } from '../../enums/simulation-type.enum';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-layout-edicao',
  standalone: true,
  imports: [NgIf, NgFor, NgClass, RouterModule, StepperNavigationComponent, PopupValidacaoComponent],
  templateUrl: './layout-edicao.component.html',
  styleUrl: './layout-edicao.component.scss'
})
export class LayoutEdicaoComponent implements OnInit, OnDestroy {
  // Dados da sidebar (igual ao layout-resultado)
  tituloResultado: string = '';
  corBordaTitulo: string = '';
  corTextoTitulo: string = '';

  redeSelecionada: string = '';
  pais: string = '';
  estado: string = '';
  cidade: string = '';
  ano: string = '';

  imagemFundo: string = 'assets/ilustrations/bridge-mountain.svg';

  // Controle do popup de inconsistências (alternar para 'true' para visualizar por enquanto)
  public mostrarPopupValidacao = false;

  public opcoes: Opcoes[] = [];
  public opcaoAtual: number = 0;
  public rotaResultado: string = '';

  private destroy$ = new Subject<void>();

  @ViewChild(RouterOutlet) routerOutlet!: RouterOutlet;

  constructor(
    private router: Router,
    private etapasDeEdicaoService: EtapasDeEdicaoService,
    private layoutResultadoService: LayoutResultadoService,
    private layoutEdicaoService: LayoutEdicaoService,
    private stepperEstadoService: StepperEstadoService,
    private localizacaoService: LocalizacaoService,
    private matriculasPorEscolaService: MatriculasPorEscolaService,
    private acessoOfertaEducacionalStateService: AcessoOfertaEducacionalStateService,
    private pQRTamanhoTurmaService: PQRTamanhoTurmaService,
    private pQRTamanhoMinimoTurmaService: PQRTamanhoMinimoTurmaService,
    private pQRNumeroDiasLetivosService: PQRNumeroDiasLetivosService,
    private pQRNovasSalasPrediosService: PQRNovasSalasPrediosService,
    private pQRCargaHorarioEnsinoService: PQRCargaHorarioEnsinoService,
    private pQRAlimentacaoEscolarService: PQRAlimentacaoEscolarService,
    private condicaoQualidadeStateService: CondicaoQualidadeStateService,
    private pQRManutencaoFormacaoMaterialService: PQRManutencaoFormacaoMaterialService,
    private pQRQuadroFuncionariosRemuneracaoService: PQRQuadroFuncionariosRemuneracaoService,
    private pQRFormacaoJornadaRemuneracaoProfessoresService: PQRFormacaoJornadaRemuneracaoProfessoresService,
    private pqrEncargosSociaisService: PQREncargosSociaisService,
    private pqrAdicionaisService: PQRAdicionaisService,
    private precoEncargosAdicionaisStateService: PrecoEncargosAdicionaisStateService,
    private validacaoEtapaService: ValidacaoEtapaService,
    private featureFlagService: FeatureFlagService,
    private pqrFatorPonderacao: PQRFatorPonderacaoService,
    private pqrMultiplicadorAnualService: PQRMultiplicadorAnualService
  ) {
    layoutEdicaoService.getTituloEdicao().subscribe(titulo => {
      this.tituloResultado = titulo;
    })

    layoutEdicaoService.getCorTituloEdicao().subscribe(cor => {
      this.corTextoTitulo = cor;
    })

    layoutEdicaoService.getCorBordaEdicao().subscribe(cor => {
      this.corBordaTitulo = cor;
    })
  }

  async ngOnInit(): Promise<void> {

    // Método para conectar com o EtapasDeEdicaoService
    this.inicializarDadosBasicos();

    // Inicializar informações da localização selecionado pelo usuário anteriormente
    this.inicializarInformacoesLocalizacao();

    // Verifica necessidade de habilitar/desabilitar a Etapa 1 conforme loc. escolhida anteriormente
    this.desabilitarEtapasComBaseNaLocalizacao();

    this.desabilitarEtapaNovasSalasSeNecessario();

    this.desabilitarEtapaFatorPonderacaoSeNecessario();

    this.navegarParaPrimeiraEtapaHabilitada();

    // Carregamento inicial dos dados das tabelas
    try {
      await this.carregarDadosIniciais();
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
    }

    // Registra callbacks de validação no service
    this.registrarValidacaoCallbacks();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    // Remove callbacks ao destruir o componente
    this.validacaoEtapaService.removerValidadorLayout();
  }

  gerarResultado() {
    this.router.navigate([this.rotaResultado]);
  }

  // Integração com o EtapasDeEdicaoService por subscribes
  private inicializarDadosBasicos(): void {
    //Lista de etapas
    this.etapasDeEdicaoService.getOpcoes().pipe(
      takeUntil(this.destroy$)
    ).subscribe((opcoes) => {
      this.opcoes = opcoes;
    });

    //Etapa atual
    this.etapasDeEdicaoService.getOpcaoAtual().pipe(
      takeUntil(this.destroy$)
    ).subscribe((opcao) => {
      this.opcaoAtual = opcao;
    });

    // Obtém a rota atual e observa mudanças
    this.layoutResultadoService.getRotaResultado().pipe(
      takeUntil(this.destroy$)
    ).subscribe((rota) => {
      if (rota) {
        this.stepperEstadoService.setRotaResultado(rota);
        this.rotaResultado = rota;
      }
    });

    // Subscribe para receber mudanças na imagem de fundo
    this.layoutEdicaoService.getImagemFundo().pipe(
      takeUntil(this.destroy$)
    ).subscribe((imagemFundo) => {
      this.imagemFundo = imagemFundo;
    });

    // Subscribes para informações da sidebar (seguindo padrão do layout-resultado)
    this.layoutEdicaoService.getRedeSelecionada().pipe(
      takeUntil(this.destroy$)
    ).subscribe((redeSelecionada) => {
      this.redeSelecionada = redeSelecionada;
    });

    this.layoutEdicaoService.getPais().pipe(
      takeUntil(this.destroy$)
    ).subscribe((pais) => {
      this.pais = pais;
    });

    this.layoutEdicaoService.getEstado().pipe(
      takeUntil(this.destroy$)
    ).subscribe((estado) => {
      this.estado = estado;
    });

    this.layoutEdicaoService.getCidade().pipe(
      takeUntil(this.destroy$)
    ).subscribe((cidade) => {
      this.cidade = cidade;
    });

    this.layoutEdicaoService.getAno().pipe(
      takeUntil(this.destroy$)
    ).subscribe((ano) => {
      this.ano = ano;
    });
  }

  // Usando o service de localização para consultar a seleção do usuário guardada no sessionStorage
  private inicializarInformacoesLocalizacao(): void {
    const localizacao = this.localizacaoService.obterLocalizacaoSelecionada();
    if (localizacao) {
      // Obtém o texto correto do plano (copiando exatamente do layout-resultado)
      const planoSelecionado = this.localizacaoService
        .obterOpcoesPlanoEducacional(localizacao)
        .find(opcao => opcao.value === localizacao.tipoSimulacaoSelecionado);

      // Define a imagem via service (como no layout-resultado)
      const imagemFundo = this.obterImagemPorTipoPlano(localizacao);
      this.layoutEdicaoService.setImagemFundo(imagemFundo);

      // Copia exatamente a implementação do relatorio-previsao-orcamentaria.component.ts
      if (this.ehEdicaoNivelEscola()) {
        this.layoutEdicaoService.setRedeSelecionada(localizacao.escolaSelecionada!.nomeInstituicao);
      } else if (planoSelecionado?.label) {
        this.layoutEdicaoService.setRedeSelecionada(planoSelecionado.label);
      }

      this.layoutEdicaoService.setPais('Brasil');

      if (localizacao?.estadoSelecionado) {
        this.layoutEdicaoService.setEstado(localizacao.estadoSelecionado.sigla);
      } else {
        this.layoutEdicaoService.setEstado('');
      }

      if (localizacao?.cidadeSelecionada?.label) {
        this.layoutEdicaoService.setCidade(localizacao.cidadeSelecionada.label);
      } else {
        this.layoutEdicaoService.setCidade('');
      }

      this.layoutEdicaoService.setAno('2026');
    }
  }

  // Determina a imagem baseada no tipo de plano educacional (igual ao layout-resultado)
  private obterImagemPorTipoPlano(localizacao: any): string {
    if (!localizacao) {
      return 'assets/ilustrations/bridge-mountain.svg';
    }

    if (localizacao.cidadeSelecionada) {
      // Municipal - usar sigla do estado
      const siglaEstado = localizacao.estadoSelecionado?.sigla || ''; //
      return `assets/ilustrations/Municípios/Estado=${siglaEstado}, Size=SM.svg`;
    } else if (localizacao.estadoSelecionado) {
      // Estadual
      const siglaEstado = localizacao.estadoSelecionado.sigla;
      return `assets/ilustrations/Maps/Estado=${siglaEstado}, Size=SM, Stroke=True.svg`;
    } else {
      // Nacional
      return 'assets/ilustrations/Maps/Estado=BR, Size=SM, Stroke=True.svg';
    }
  }

  // Quando o usuário clicar em uma etapa
  onStepperNavegacao(evento: EventoNavegacaoStepper): void {
    // Navegação direta sem validação por enquanto (TODO)
    this.router.navigate([evento.rota]);
  }

  // Eventos do PopupValidacaoComponent (TODO)
  onPopupFechar(): void {
    this.mostrarPopupValidacao = false;
  }

  onPopupContinuarMesmoAssim(): void {
    this.mostrarPopupValidacao = false;
  }

  onPopupCorrigirErros(): void {
    this.mostrarPopupValidacao = false;
  }

  // Desabilita a etapa de Novas Salas se a simulação for de Plano (múltiplas redes)
  private desabilitarEtapaNovasSalasSeNecessario(): void {
    const etapaNovasSalasId = 13; // ID fixo conforme EtapasDeEdicaoService

    // Se a feature flag está desabilitada, desabilita sempre
    if (!this.featureFlagService.funcionalidadeHabilitada('novas-salas')) {
      this.etapasDeEdicaoService.desabilitarOpcao(etapaNovasSalasId);
      return;
    }

    // Feature habilitada, aplica lógica original de bloqueio por tipo de simulação

    const localizacaoSelecionada = this.localizacaoService.obterLocalizacaoSelecionada();

    if (!localizacaoSelecionada || !localizacaoSelecionada.tipoSimulacaoSelecionado) {
      return;
    }

    const tipoSimulacao = Number(localizacaoSelecionada.tipoSimulacaoSelecionado);
    // Tipos de simulação que PERMITEM edição (Rede Única)
    const tiposPermitidos = [
      TipoSimulacao.planejamentoPorEsferaAdmEstadual,
      TipoSimulacao.planejamentoPorEsferaAdmMunicipal
    ];

    if (tiposPermitidos.includes(tipoSimulacao)) {
      this.etapasDeEdicaoService.habilitarOpcao(etapaNovasSalasId);
    } else {
      this.etapasDeEdicaoService.desabilitarOpcao(etapaNovasSalasId);
    }

  }

  private desabilitarEtapaFatorPonderacaoSeNecessario(): void {
    const etapaFatorPonderacao = 25;

  }

  // Habilita Seção 1 (Acesso e Oferta Educacional) apenas para o âmbito municipal
  private desabilitarEtapasComBaseNaLocalizacao(): void {
    const localizacaoSelecionada = this.localizacaoService.obterLocalizacaoSelecionada();

    if (!localizacaoSelecionada) {
      console.warn('[LayoutEdicao] Nenhuma localização encontrada no sessionStorage');
      return;
    }

    const ehMunicipal = !!localizacaoSelecionada.cidadeSelecionada && !this.ehEdicaoNivelEscola();

    if (ehMunicipal) {
      this.stepperEstadoService.habilitarSecao(1);
      // Mantém a etapa 4 desabilitada (Divisão da responsabilidade pela oferta)
      this.stepperEstadoService.desabilitarEtapa(4);
    } else {
      this.stepperEstadoService.desabilitarSecao(1);
    }
  }

  // No R Custo por escola com escola selecionada, apenas os PQRs são editáveis (sem Seção 1)
  private ehEdicaoNivelEscola(): boolean {
    return this.featureFlagService.funcionalidadeHabilitada('1436-inserir-edicao-nivel-escola')
      && this.rotaResultado === '/resultado/relatorio-custo-por-escola'
      && !!this.localizacaoService.obterEscolaSelecionada();
  }

  // Carregamento dos dados de todas as etapas de uma vez (necessário para alimentar o service das tabelas)
  private async carregarDadosIniciais(): Promise<void> {
    const ehMunicipal = this.localizacaoService.ehLocalizacaoMunicipal() && !this.ehEdicaoNivelEscola();

    // Só carrega dados de matrícula se for municipal e se nao tiver carregado antes
    if (ehMunicipal && this.acessoOfertaEducacionalStateService.getProjecoesOfertaMatriculas().length === 0) {
      this.acessoOfertaEducacionalStateService.carregando.next(true);

      const projecoes = await this.matriculasPorEscolaService.buscarMatriculasPorEscola();
      this.acessoOfertaEducacionalStateService.setProjecoesOfertaMatriculas(projecoes);

      this.acessoOfertaEducacionalStateService.carregando.next(false);
    }

    this.condicaoQualidadeStateService.carregando.next(true);

    // Dados de PQR (pqr.json) obtidos dos endpoints gerados automaticamente pelo Spring (repositories)
    const loadPQRNumeroDiasLetivos = new Promise<void>((resolve) => {
      this.pQRNumeroDiasLetivosService
        .buscarListaDePQRNumeroDiasLetivos()
        .subscribe((values) => {
          this.condicaoQualidadeStateService.setPQRNumeroDiasLetivosPadrao(values);
          if (this.condicaoQualidadeStateService.getPQRNumeroDiasLetivosValores().length === 0) {
            this.condicaoQualidadeStateService.setPQRNumeroDiasLetivosValores(values);
          }
          resolve();
        });
    });

    const loadPQRCargaHorarioEnsino = new Promise<void>((resolve) => {
      this.pQRCargaHorarioEnsinoService
        .buscarListaDePQRCargaHorarioEnsino()
        .subscribe((values) => {
          this.condicaoQualidadeStateService.setPQRCargaHorarioEnsinoPadrao(values);
          if (this.condicaoQualidadeStateService.getPQRCargaHorarioEnsinoValores().length === 0) {
            this.condicaoQualidadeStateService.setPQRCargaHorarioEnsinoValores(values);
          }
          resolve();
        });
    });

    const loadPQRAlimentacaoEscolar = new Promise<void>((resolve) => {
      this.pQRAlimentacaoEscolarService
        .buscarListaDePQRAlimentacaoEscolar()
        .subscribe((values) => {
          this.condicaoQualidadeStateService.setPQRAlimentacaoEscolarPadrao(values);
          if (this.condicaoQualidadeStateService.getPQRAlimentacaoEscolarValores().length === 0) {
            this.condicaoQualidadeStateService.setPQRAlimentacaoEscolarValores(values);
          }
          resolve();
        });
    });

    const loadPQRManutencaoFormacaoMaterial = new Promise<void>((resolve) => {
      this.pQRManutencaoFormacaoMaterialService
        .buscarListaDePQRManutencaoFormacaoMaterial()
        .subscribe((values) => {
          this.condicaoQualidadeStateService.setPQRManutencaoFormacaoMaterialPadrao(values);
          if (this.condicaoQualidadeStateService.getPQRManutencaoFormacaoMaterialValores().length === 0) {
            this.condicaoQualidadeStateService.setPQRManutencaoFormacaoMaterialValores(values);
          }
          resolve();
        });
    });

    const loadPQRTamanhoTurmas = new Promise<void>(resolve => {
      this.pQRTamanhoTurmaService
        .buscarListaDePQRTamanhoTurma()
        .subscribe((values) => {
          this.condicaoQualidadeStateService.setPQRTamanhoTurmasPadrao(values);
          if (this.condicaoQualidadeStateService.getPQRTamanhoTurmasValores().length === 0) {
            this.condicaoQualidadeStateService.setPQRTamanhoTurmasValores(values);
          }
          resolve();
        });
    });

    const loadPQRTamanhoMinimoTurmas = new Promise<void>((resolve) => {
      if (
        !this.featureFlagService.funcionalidadeHabilitada('1104-creche-idade') ||
        !this.featureFlagService.funcionalidadeHabilitada('1108-pqr-minimo-turma')
      ) {
        resolve();
        return;
      }
      this.pQRTamanhoMinimoTurmaService.buscarListaDePQRTamanhoMinimoTurma().subscribe((values) => {
        this.condicaoQualidadeStateService.setPQRMinimoTurmasPadrao(values);
        if (this.condicaoQualidadeStateService.getPQRMinimoTurmasValores().length === 0) {
          this.condicaoQualidadeStateService.setPQRMinimoTurmasValores(values);
        }
        resolve();
      });
    });

    const loadPQRCarreiraRemuneracaoProfessoresService = new Promise<void>(resolve => {
      this.pQRFormacaoJornadaRemuneracaoProfessoresService
        .buscarListaDePQRFormacaoJornadaRemuneracaoProfessores()
        .subscribe((values) => {
          const valuesCorrigidos = values.map(item => ({
            ...item,
            distribuicaoNiveisCarreira: item.distribuicaoNiveisCarreira || 100
          }));

          this.condicaoQualidadeStateService.setPQRFormacaoJornadaRemuneracaoProfessoresPadrao(valuesCorrigidos);
          if (this.condicaoQualidadeStateService.getPQRFormacaoJornadaRemuneracaoProfessoresValores().length === 0) {
            this.condicaoQualidadeStateService.setPQRFormacaoJornadaRemuneracaoProfessoresValores(valuesCorrigidos);
          }
          resolve();
        });
    });

    const loadPQRQuadroFuncionariosRemuneracao = new Promise<void>(resolve => {
      this.pQRQuadroFuncionariosRemuneracaoService
        .buscarListaDePQRQuadroFuncionariosRemuneracao()
        .subscribe((values) => {
          this.condicaoQualidadeStateService.setPQRQuadroFuncionariosRemuneracaoPadrao(values);
          if (this.condicaoQualidadeStateService.getPQRQuadroFuncionariosRemuneracaoValores().length === 0) {
            this.condicaoQualidadeStateService.setPQRQuadroFuncionariosRemuneracaoValores(values);
          }
          resolve();
        });
    });

    const loadPQRNovasSalasPredios = new Promise<void>((resolve) => {
      this.pQRNovasSalasPrediosService
        .buscarListaDePQRNovasSalasPredios()
        .subscribe((values) => {
          this.condicaoQualidadeStateService.setPQRNovasSalasPrediosPadrao(values);
          resolve();
        });
    });

    const loadPQRFatorPonderacao = new Promise<void>((resolve) => {

      this.pqrFatorPonderacao
        .buscarPQRFatorPonderacao()
        .subscribe((values) => {
          this.condicaoQualidadeStateService.setPQRFatorPonderacaoPadrao([values]);
          if (this.condicaoQualidadeStateService.getPQRFatorPonderacaoValores().length === 0) {
            this.condicaoQualidadeStateService.setPQRFatorPonderacaoValores([values]);
          }
          resolve();
        });
    });

    Promise.all([
      loadPQRTamanhoTurmas,
      loadPQRTamanhoMinimoTurmas,
      loadPQRNumeroDiasLetivos,
      loadPQRNovasSalasPredios,
      loadPQRCargaHorarioEnsino,
      loadPQRAlimentacaoEscolar,
      loadPQRManutencaoFormacaoMaterial,
      loadPQRQuadroFuncionariosRemuneracao,
      loadPQRCarreiraRemuneracaoProfessoresService,
      loadPQRFatorPonderacao
    ]).then(
      () => {
        this.condicaoQualidadeStateService.carregando.next(false);
      },
    );

    const loadPQREncargosSociais = new Promise<void>((resolve) => {
      this.pqrEncargosSociaisService
        .buscarListaDePQREncargosSociais()
        .subscribe((values) => {
          if (this.precoEncargosAdicionaisStateService.getPQREncargosSociaisValores().length === 0) {
            this.precoEncargosAdicionaisStateService.setPQREncargosSociaisPadrao(values);
            this.precoEncargosAdicionaisStateService.setPQREncargosSociaisValores(values);
          }
          resolve();
        });
    });

    const loadPQRAdicionais = new Promise<void>((resolve) => {
      this.pqrAdicionaisService
        .buscarListaDePQRAdicionais()
        .subscribe((values) => {
          if (this.precoEncargosAdicionaisStateService.getPQRAdicionaisValores().length === 0) {
            this.precoEncargosAdicionaisStateService.setPQRAdicionaisPadrao(values);
            this.precoEncargosAdicionaisStateService.setPQRAdicionaisValores(values);
          }
          resolve();
        });
    });

    const loadPQRMultiplicadorAnual = new Promise<void>((resolve) => {
      this.pqrMultiplicadorAnualService
        .buscarListaDePQRMultiplicadorAnual()
        .subscribe((values) => {
          if (this.precoEncargosAdicionaisStateService.getPQRMultiplicadorAnualValores().length === 0) {
            this.precoEncargosAdicionaisStateService.setPQRMultiplicadorAnualPadrao(values);
            this.precoEncargosAdicionaisStateService.setPQRMultiplicadorAnualValores(values);
          }
          resolve();
        });
    });

    Promise.all([
      loadPQREncargosSociais,
      loadPQRAdicionais,
      loadPQRMultiplicadorAnual
    ]).then(
      () => {
        this.precoEncargosAdicionaisStateService.carregando.next(false);
      },
    );
  }

  // Registra callbacks de validação com o service
  private registrarValidacaoCallbacks(): void {
    this.validacaoEtapaService.registrarValidadorLayout(
      () => this.validarTelaAtual(),
      () => this.restaurarValoresPadrao()
    );
  }

  // Identifica e valida o componente atual chamando a função "validar" da tabela
  private validarTelaAtual(): ValidacaoResult {
    const componenteAtual = this.obterComponenteAtual();

    if (componenteAtual && typeof componenteAtual.validar === 'function') {
      return componenteAtual.validar();
    }

    // Se não houver validador, assume que está válido
    return { valido: true, mensagens: [] };
  }

  // Restaura valores padrão do componente atual
  private restaurarValoresPadrao(): void {
    const componenteAtual = this.obterComponenteAtual();

    if (componenteAtual && typeof componenteAtual.restaurarValoresPadrao === 'function') {
      componenteAtual.restaurarValoresPadrao();
    }
  }

  // Obtém o componente atualmente ativo no RouterOutlet
  private obterComponenteAtual(): ValidadorTela | null {
    if (!this.routerOutlet || !this.routerOutlet.component) {
      return null;
    }

    const component = this.routerOutlet.component;

    // Verifica se o componente implementa ValidadorTela
    if (this.implementaValidadorTela(component)) {
      return component as ValidadorTela;
    }

    return null;
  }

  // Type guard para verificar se um objeto implementa ValidadorTela
  private implementaValidadorTela(obj: any): obj is ValidadorTela {
    return obj &&
      typeof obj.validar === 'function' &&
      typeof obj.restaurarValoresPadrao === 'function';
  }

  private navegarParaPrimeiraEtapaHabilitada(): void {
    const ehMunicipal = this.localizacaoService.ehLocalizacaoMunicipal() && !this.ehEdicaoNivelEscola();

    // Se não for municipal, navega para a primeira etapa da Seção 2
    if (!ehMunicipal) {
      this.etapasDeEdicaoService.getOpcoes().pipe(
        take(1)
      ).subscribe(opcoes => {
        // Encontra a primeira etapa habilitada da Seção 2
        const primeiraEtapaSecao2 = opcoes.find(
          opcao => opcao.sectionId === 2 && !opcao.desabilitado
        );

        if (primeiraEtapaSecao2) {
          const caminhoBase = this.router.url.split('/').slice(0, 2).join('/');
          const rotaCompleta = `${caminhoBase}${primeiraEtapaSecao2.rota}`;
          this.router.navigate([rotaCompleta], { replaceUrl: true });
          this.etapasDeEdicaoService.setOpcaoAtual(primeiraEtapaSecao2.id);
        }
      });
    }
  }
}

